/**
 * @copyright Swoo Inc
 * @website http://swoo.ca
 * @author Jonathan Simard <jonathan@swoo.ca>
 */
export default class Meteo{
	constructor(){
		console.log('Footer :: Meteo :: init');

		this.view = document.querySelector('.footer_meteo');

		if(!this.view) return;

		let urls = [];
		this.view.querySelectorAll('.box').forEach(box => {
			urls.push("https://api.openweathermap.org/data/2.5/weather?lat="+box.getAttribute('data-lat')+"&lon="+box.getAttribute('data-lng')+"&appid=8be97178604e5119070ee31d0b084236")	
		});
		
		urls.forEach((args,i) => {
			this.icon = '';

			$.getJSON(args, (weatherData) => {
				var weather = String(weatherData.weather[0].id);
				// translate Kelvin to Celsius
				var celsius = Math.floor(weatherData.main.temp - 273.15);

				if(weather.substr(0,1) == 2){
					this.icon = 'thunderstorm';
				}else if(weather.substr(0,1) == 3){
					this.icon = 'drizzle';
				}else if(weather.substr(0,1) == 5){
					this.icon = 'rain';
				}else if(weather.substr(0,1) == 6){
					this.icon = 'snow';
				}else if(weather.substr(0,1) == 7 || weather.substr(0,1) == 9){
					this.icon = 'atmosphere';
				}else if(weather == 800){
					this.icon = 'sun';
				}else if(weather == 801){
					this.icon = 'sun';
				}else if(weather == 802){
					this.icon = 'clouds';
				}else if(weather == 803){
					this.icon = 'clouds';
				}else if(weather.substr(0,1) == 8){
					this.icon = 'clouds';
				}
				console.log(weather);
				document.querySelector('.footer_meteo .box:nth-child('+(i+1)+') svg use').setAttribute('xlink:href','#'+this.icon);
				document.querySelector('.footer_meteo .box:nth-child('+(i+1)+') .number').textContent = celsius;
			});

		});
	}
}